"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uniqueIdType = exports.allConstraintNames = exports.GraphType = exports.FormFieldTypes = void 0;
let uniqueIdType = exports.uniqueIdType = /*#__PURE__*/function (uniqueIdType) {
  uniqueIdType["RULE"] = "rule-id-";
  uniqueIdType["SUBRULE"] = "sub-rule-id";
  uniqueIdType["SUBFORM"] = "sub-form-id-";
  uniqueIdType["FIELD"] = "field-id-";
  uniqueIdType["CONDITION"] = "condition-id-";
  uniqueIdType["SECTION"] = "section-id-";
  uniqueIdType["WIDGET"] = "widget-id-";
  return uniqueIdType;
}({});
let GraphType = exports.GraphType = /*#__PURE__*/function (GraphType) {
  GraphType["CHART"] = "CHART";
  GraphType["TABLE"] = "TABLE";
  return GraphType;
}({});
let FormFieldTypes = exports.FormFieldTypes = /*#__PURE__*/function (FormFieldTypes) {
  FormFieldTypes["TEXT_INPUT"] = "TEXT_INPUT";
  FormFieldTypes["TEXT_AREA"] = "TEXT_AREA";
  FormFieldTypes["MULTIPLE_CHOICES"] = "MULTIPLE_CHOICES";
  FormFieldTypes["DROPDOWN"] = "DROPDOWN";
  FormFieldTypes["DATE_INPUT"] = "DATE_INPUT";
  FormFieldTypes["TIME_PICKER"] = "TIME_PICKER";
  FormFieldTypes["LINEAR_SCALING"] = "LINEAR_SCALING";
  FormFieldTypes["FILE_UPLOAD"] = "FILE_UPLOAD";
  FormFieldTypes["CURRENCY"] = "CURRENCY";
  FormFieldTypes["RATING"] = "RATING";
  FormFieldTypes["DATE_TIME_PICKER"] = "DATE_TIME_PICKER";
  FormFieldTypes["CHECK_BOX"] = "CHECK_BOX";
  FormFieldTypes["NUMBER_INPUT"] = "NUMBER_INPUT";
  FormFieldTypes["DECIMAL"] = "DECIMAL";
  FormFieldTypes["DECISION_BOX"] = "DECISION_BOX";
  FormFieldTypes["CALCULATIVE"] = "CALCULATIVE";
  FormFieldTypes["PAGE_BREAK"] = "PAGE_BREAK";
  FormFieldTypes["PAYMENT"] = "PAYMENT";
  FormFieldTypes["DESCRIPTION"] = "DESCRIPTION";
  FormFieldTypes["BLANK_BOX"] = "BLANK_BOX";
  FormFieldTypes["SECTION"] = "SECTION";
  FormFieldTypes["LOOKUP"] = "LOOKUP";
  FormFieldTypes["YEAR_SELECTOR"] = "YEAR_SELECTOR";
  FormFieldTypes["SEQUENCE"] = "SEQUENCE";
  return FormFieldTypes;
}({});
let allConstraintNames = exports.allConstraintNames = /*#__PURE__*/function (allConstraintNames) {
  allConstraintNames["IS"] = "Is";
  allConstraintNames["IS_NOT"] = "Is Not";
  allConstraintNames["IS_EMPTY"] = "Is Empty";
  allConstraintNames["IS_NOT_EMPTY"] = "Is Not Empty";
  allConstraintNames["LESS_THAN"] = "Less Than";
  allConstraintNames["GREATER_THAN"] = "Greater Than";
  allConstraintNames["LESS_THAN_OR_EQUAL_TO"] = "Less Than or Equal To";
  allConstraintNames["GREATER_THAN_OR_EQUAL_TO"] = "Greater Than or Equal To";
  allConstraintNames["MAXIMUM_DIGIT_LENGTH"] = "Maximum Digit Length";
  allConstraintNames["CONTAINS"] = "Contains";
  allConstraintNames["NOT_CONTAINS"] = "Not Contains";
  allConstraintNames["STARTS_WITH"] = "Starts With";
  allConstraintNames["ENDS_WITH"] = "Ends With";
  allConstraintNames["MAXIMUM_TEXT_LENGTH"] = "Maximum Text Length";
  return allConstraintNames;
}({});